import React, { useEffect } from 'react';
import { generalStore } from '../../store';
import { COOKIE_KEYS, ROUTES, RESPONSE} from '../../js/_constants';
import helpers from '../../js/helpers';
import Loader from '../../components/loader/Loader';
import { auth } from '../../js/GRP';
import api from '../../api';
import { jwtDecode } from 'jwt-decode';
import { apiPatch } from '../../js/api';
import Server from '../../js/config/_server';
import { useNavigate } from 'react-router';

const ConnectView = () => {
    const navigate = useNavigate();
    const { setAuthenticated } = generalStore();

    const grpAuthorize = async () => {
        let user;
        let token;

        await auth.getIdTokenPayload().then((res) => (user = res));

        if (!user) {
            await auth.authorize();
            return;
        }

        await auth.getToken().then((res) => (token = res));
        const currentTimeEpocSec = Date.now() / 1000;
        const jwtDecodedToken = jwtDecode(token.accessToken) as any;
        const duration = jwtDecodedToken.exp - currentTimeEpocSec;
        const hours = duration / 3600;

        helpers.setCookie(COOKIE_KEYS.TOKEN, token.accessToken, hours);
        helpers.setCookie(COOKIE_KEYS.REFRESH_TOKEN, token.refreshToken, hours + 4);
        helpers.setCookie(COOKIE_KEYS.ID_TOKEN, token.idToken);

        setAuthenticated(true);

        const idToken = token.idToken;
        const url = Server.baseUrl + Server.services.users.me;
        const options = {
            body: {
                idToken: idToken
            }
        };

        await apiPatch(url, options);

        const me = await api.getUser();

        const redirectUrl = localStorage.getItem('redirectUrl');

        if(redirectUrl) {
            localStorage.removeItem('redirectUrl');
            return navigate(redirectUrl)
        }

        return navigate(ROUTES.DASHBOARD);

        // return me.showTutorial
        //     ? navigate(ROUTES.ONBOARDING)
        //     : navigate(ROUTES.DASHBOARD);

    };

    useEffect(() => {
        grpAuthorize();
    }, []);

    return (
        <div className="b-connect-view">
            <Loader loading />
        </div>
    );
};

export default ConnectView;
